'use client'

import { useEffect, useState } from 'react'
import { UAParser } from 'ua-parser-js'

type DeviceType = 'mobile' | 'tablet' | 'desktop'

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop')

  useEffect(() => {
    const parser = new UAParser()
    const type = parser.getDevice().type as DeviceType | undefined
    // eslint-disable-next-line react-hooks/set-state-in-effect -- syncing state from UAParser/navigator.userAgent (external system)
    setDeviceType(type || 'desktop')
  }, [])

  return deviceType
}

export function useIsMobileClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'mobile'
}

export function useIsTabletClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'tablet'
}

export function useIsMobileOrTabletClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'mobile' || deviceType === 'tablet'
}

export function useIsDesktopClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'desktop'
}

export function useIsIOSClient(): boolean {
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- syncing state from navigator.userAgent (external system)
    setIsIOS(/iPhone|iPad|iPod/i.test(navigator.userAgent))
  }, [])

  return isIOS
}

export function useIsAndroidClient(): boolean {
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- syncing state from navigator.userAgent (external system)
    setIsAndroid(/Android/i.test(navigator.userAgent))
  }, [])

  return isAndroid
}
